import React, { useState } from 'react';
import { useActor } from '../app/ActorContext';
import { apiJson } from '../services/api';
import './TeamAccess.css';


const ROLES = [
  ['investor_member', 'Investor member'],
  ['deal_finder', 'Deal finder'],
  ['contractor', 'Contractor'],
  ['inspector', 'Inspector'],
  ['virtual_assistant', 'Virtual assistant'],
  ['tenant', 'Tenant'],
];

export default function TeamAccess() {
  const { hasPermission } = useActor();
  const [email, setEmail] = useState('');
  const [roleKey, setRoleKey] = useState('contractor');
  const [inviteUrl, setInviteUrl] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!hasPermission('membership.manage')) {
    return <main className="team-access"><h1>Team access</h1><p>You do not have permission to manage members.</p></main>;
  }

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    setInviteUrl('');
    try {
      const result = await apiJson('/identity/invitations', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, role_key: roleKey }),
      });
      setInviteUrl(`${window.location.origin}/register?invitation=${encodeURIComponent(result.token)}`);
    } catch (requestError) {
      setError(requestError?.message || 'Could not create the invitation.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="team-access">
      <header><p>Organization</p><h1>Team access</h1><span>Invite one person and assign their starting role.</span></header>
      <form onSubmit={submit}>
        <label>Email<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} required /></label>
        <label>Role<select value={roleKey} onChange={(event) => setRoleKey(event.target.value)}>{ROLES.map(([key, label]) => <option key={key} value={key}>{label}</option>)}</select></label>
        <button type="submit" disabled={submitting}>{submitting ? 'Creating invitation…' : 'Create invitation'}</button>
      </form>
      {error && <p className="team-access__error" role="alert">{error}</p>}
      {inviteUrl && <section className="team-access__result"><strong>Invitation link</strong><p>Send this link only to the invited person. Creating another invitation for the same email and role replaces it.</p><input aria-label="Invitation link" value={inviteUrl} readOnly onFocus={(event) => event.target.select()} /></section>}
    </main>
  );
}
